import script from "./sql.vue?vue&type=script&setup=true&lang=js"
export * from "./sql.vue?vue&type=script&setup=true&lang=js"

import "./sql.vue?vue&type=style&index=0&id=ac8c93ee&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8c93ee"]])

export default __exports__